import React from "react";
import logoUrl from "@/assets/jktofqg-logo.png";

// Official E-System JKTOFQG logo (image asset, do not redraw)
export default function BrandLogo({ size = 40, className = "" }) {
  return (
    <img
      src={logoUrl}
      alt="E-System JKTOFQG"
      width={size}
      height={size}
      className={"object-contain " + className}
      style={{ width: size, height: size }}
      draggable={false}
    />
  );
}
